/**
 * Queue toggle button ("My Queue" / Watch Later).
 *
 * Delegated click handler — works for buttons rendered on initial page load
 * *and* inside dynamically-swapped content (e.g. a carousel), since we listen
 * on document rather than binding to each button individually.
 */
function setButtonState(button, queued) {
  button.dataset.queued = queued ? '1' : '0';
  button.setAttribute('aria-pressed', queued ? 'true' : 'false');
  button.classList.toggle('is-queued', queued);

  const label = button.querySelector('[data-queue-label]');
  if (label) {
    label.textContent = queued
      ? label.dataset.queuedLabel || 'In Queue'
      : label.dataset.addLabel || 'Add to Queue';
  }
}

async function toggleQueue(button) {
  if (button.dataset.loading === '1') return;

  const entryId = button.dataset.entryId;
  if (!entryId) return;

  button.dataset.loading = '1';
  button.classList.add('opacity-60', 'pointer-events-none');

  const body = { entryId };
  if (window.csrfTokenName && window.csrfToken) {
    body[window.csrfTokenName] = window.csrfToken;
  }

  try {
    const response = await fetch('/watch-queue/toggle', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': window.csrfToken || '',
      },
      body: JSON.stringify(body),
    });

    const data = await response.json();

    if (data && data.success) {
      setButtonState(button, data.queued);

      // Every other button on the page pointing at the same entry (e.g. a card
      // in a carousel + its detail page) should reflect the new state too.
      document
        .querySelectorAll(`[data-queue-toggle][data-entry-id="${entryId}"]`)
        .forEach((btn) => {
          if (btn !== button) setButtonState(btn, data.queued);
        });

      document.dispatchEvent(
        new CustomEvent('queue:changed', {
          detail: { entryId, queued: data.queued, count: data.count },
        }),
      );
    } else if (data && data.message) {
      window.location.href = '/login';
    }
  } catch (error) {
    console.debug('Queue toggle failed:', error);
  } finally {
    button.dataset.loading = '0';
    button.classList.remove('opacity-60', 'pointer-events-none');
  }
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-queue-toggle]');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();
  toggleQueue(button);
});


